import { render, staticRenderFns } from "./Myvocoviewtemplate.vue?vue&type=template&id=8bf03a62&scoped=true&"
import script from "./Myvocoviewtemplate.vue?vue&type=script&lang=js&"
export * from "./Myvocoviewtemplate.vue?vue&type=script&lang=js&"
import style0 from "./Myvocoviewtemplate.vue?vue&type=style&index=0&id=8bf03a62&scoped=true&lang=css&"
import style1 from "./Myvocoviewtemplate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf03a62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
